import { Component, Host, h } from "@stencil/core";

@Component({
    tag: 'app-share',
    styleUrl: 'component.css',
    shadow: true
})
export class AppShareComponent {

    available = navigator.share !== undefined;

    render() {

        if (!this.available) return;

        return <Host
            title="Share this page"
            onClick={this.share}
        >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="-14 -14 28 28" version="1.1">
                <path
                    d="
                    M-9,-7 A1,1 0,0,1 -2,-7 A1,1 0,0,1 -9,-7
                    M-9,7 A1,1 0,0,1 -2,7 A1,1 0,0,1 -9,7
                    M9,0 A1,1 0,0,1 2,0 A1,1 0,0,1 9,0
                    M-5,-8 5,-2 5,2 -5,8 -5,6 5,0 -5,-6
                " />
            </svg>
        </Host>;
    }

    share = async () => {

        let metaData: Record<string, string>
            = { title: 'og:title', text: 'og:description' };
        metaData = Object.keys(metaData)
            .reduce((metaData, key) => {
                let metaTag = document.head
                    .querySelector<HTMLMetaElement>(`[property="${metaData[key]}"]`);
                if (metaTag)
                    metaData[key] = metaTag.content;

                return metaData;
            }, metaData);

        const shareData = {
            ...metaData,
            url: location.href
        };

        console.debug(shareData);

        await navigator.share(shareData);
    }
}